import * as React from "react";
import { X } from "lucide-react";

import { cn } from "@/lib/utils";

export const MODAL_CLOSE_BUTTON_CLASS =
    "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-red-800/30 bg-red-600 text-white shadow-sm transition-colors hover:bg-red-700 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50";

type ModalCloseButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const ModalCloseButton = React.forwardRef<HTMLButtonElement, ModalCloseButtonProps>(
    ({ className, children, type = "button", ...props }, ref) => (
        <button
            ref={ref}
            type={type}
            className={cn(MODAL_CLOSE_BUTTON_CLASS, className)}
            {...props}
        >
            {children ?? <X className="h-5 w-5" aria-hidden="true" />}
            <span className="sr-only">Close</span>
        </button>
    )
);

ModalCloseButton.displayName = "ModalCloseButton";

export default ModalCloseButton;
